import { Component } from "@angular/core";

@Component({
	selector: "caass-admin",
	templateUrl: "./admin.component.html",
})
export class AdminComponent {}
